import {useCallback} from 'react';
import {useSearchParams} from 'react-router-dom';
import {PATHS} from 'routes/constants';
import {usePath} from 'hooks/common';
import {getIVIntentRemoteSession} from 'hooks/iv/ivIntentRemoteSession';

export const INTENT_ID = 'intentId';

export const useRemoteStartVerificationLink = () => {
  const {getFullPath} = usePath();

  const generateRemoteStartVerificationLink = useCallback(() => {
    const intentId = getIVIntentRemoteSession() ?? '';
    const path = getFullPath(PATHS.verification.documentSelection);

    return `${window.location.origin}${path}?${INTENT_ID}=${intentId}`;
  }, [getFullPath]);

  return {
    generateRemoteStartVerificationLink,
  };
};

export const useIsRemoteIV = () => {
  const [searchParams] = useSearchParams();

  return {
    intentId: searchParams.get(INTENT_ID),
  };
};
